module.exports = " #header{\r\n    background: #16A085;\r\n  }\r\n.grid-container {\r\n  width:90%;\r\n  display: -ms-grid;\r\n  display: grid;\r\n  -ms-grid-columns: 1fr 1fr 1fr;\r\n      grid-template-columns: 1fr 1fr 1fr;\r\n  margin-top: 20px;\r\n  margin-left:20px;\r\n  margin-right:20px;\r\n  margin-bottom: 10px;\r\n}\r\n.grid-container div{\r\n\tpadding: 10px;\r\n\tmargin:auto;\r\n}\r\n.grid-container img{\r\n\twidth: auto;\r\n\theight: 80px;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/d2z/views/international-courier/international-courier.component.css
// module id = ./src/app/d2z/views/international-courier/international-courier.component.css
// module chunks = main